<template>
  <dashboard :readonly="true" />
</template>

<script>
import Dashboard from './dashboard.vue'

export default {
  name: "dashboard-view",
  components: {
    'dashboard': Dashboard
  }
};
</script>
